import styled from 'styled-components';

export const BenchmarkingContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 212px ${({ theme }) => theme.spacing.m} 88px;
`;

export const BenchmarkingReport = styled.div`
  text-align: center;
`;

export const BlockShadow = styled.div`
  box-shadow:
    0px 0.3px 0.9px rgba(0, 0, 0, 0.1),
    0px 1.6px 3.6px rgba(0, 0, 0, 0.13);
  margin: ${({ theme }) => theme.spacing.s} ${({ theme }) => theme.spacing.none};
  padding: ${({ theme }) => theme.spacing.md};
  padding-top: ${({ theme }) => theme.spacing.none};
`;

export const BlockSpace = styled.div`
  padding: ${({ theme }) => theme.spacing.s};
  .list-ranking-item {
    width: 100%;
    margin-bottom: 88px;
  }
`;

export const BlockSpaceFlex = styled.div`
  display: flex;
`;

export const SubDepartmentUserTitle = styled.div`
  margin: ${({ theme }) => theme.spacing.s} ${({ theme }) => theme.spacing.none};
`;
